import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';
import { PatientDocumentType } from './patientDocuments';

export const medicalDocumentUploadReasons = [
  'Assessments & Evaluations',
  'Consents to treatment',
  'Documentation error addendum',
  'Lab results',
  'Previous medical records',
  'Release of information',
  'Prior Authorization',
  'Other',
] as const;

export type MedicalDocumentUploadReason = typeof medicalDocumentUploadReasons[number];

export const customMedicalDocumentUploadReasonLabel: Partial<Record<MedicalDocumentUploadReason, string>> = {
  'Other': 'Document',
};

export type MedicalDocumentRecord = {
  id: string;
  type: PatientDocumentType.medicalRecord;
  patient_id: string;
  uploaded_at: string;
  uploaded_by: 'provider' | 'Uplift';
  provider_id: string;
  reason_for_upload: MedicalDocumentUploadReason;
  additional_details: string;
  created_at: string;
  updated_at: string;
  reason_for_delete?: string;
  archived_at?: string;
};


export const getPatientMedicalDocumentRecord = async (patientId: string, medicalDocumentId: string) => restClient.request<{ data: MedicalDocumentRecord }>(
  `/api/v1/patient/${patientId}/medical_document_record/${medicalDocumentId}`
);

export const deletePatientMedicalDocumentRecord = async (patientId: string, medicalDocumentId: string, reasonForDelete: string) => restClient.request<{ data: null }>(
  `/api/v1/patient/${patientId}/medical_document_record/${medicalDocumentId}/delete`,
  {
    method: 'POST',
    data: {
      reason_for_delete: reasonForDelete,
    }
  }
);

export const createPatientMedicalDocumentRecord = async (patientId: string, data: { fileUploadId: string; reasonForUpload: string; additionalDetails: string }) => restClient.request<{ data: MedicalDocumentRecord }>(
  `/api/v1/patient/${patientId}/medical_document_record`,
  {
    method: 'POST',
    data: snakecaseKeys(data),
  }
);


export const updatePatientMedicalDocumentRecord = async (patientId: string, medicalDocumentId: string, data: { reasonForUpload: string; additionalDetails: string }) => restClient.request<{ data: null }>(
  `/api/v1/patient/${patientId}/medical_document_record/${medicalDocumentId}`,
  {
    method: 'PATCH',
    data: snakecaseKeys(data),
  }
);


export const getPatientMedicalDocumentDownloadLink = async (patientId: string, documentId: string) => restClient.request<{ data: { download_link: string } }>(
  `/api/v1/patient/${patientId}/medical_document_record/${documentId}/download_link`,
  {
    method: 'POST',
  }
);
